export default "__VITE_ASSET__eace31d6__"